<template>
  <div class="home">
    <div class="search">
      <router-link :to="'/home/ChosePlot/' + cityId" tag="div" class="drop">
        <span>{{village}}</span>
        <span class="drop-icon" v-show="village"></span>
      </router-link>
      <router-link :to="'/home/ChosePlot/' + cityId" class="search-icon" tag="span"></router-link>
    </div>
    <!--图片轮播123-->
    <div class="swiper-box">
      <mt-swipe :auto="5000">
        <mt-swipe-item v-for="(pic,pindex) in picture" :key="pindex">
          <img :src="pic.img_url" alt="">
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <ul class="mainmenu clearfix">
      <!--特殊小区直接跳转点我投小程序-->
      <li v-if="newOld=== 'voting'">
        <wx-open-launch-weapp
              id="launch-btn"
              username="gh_32dedf14a8fd"
              path="pages/guide/guidePage.html"
            >
              <script type="text/wxtag-template">
                <style>.btn{background: #ffffff;color: #000000;font-size: 14px;border: none;outline: none;margin-top: 2px;}
                </style>
              <div style="width: 100%;margin-top: 14px;margin-left: 14px;">
                <div style="width: 48px;height: 48px;margin-left: 7px;" >
                <img style="width: 100%;height: 100%;" src="https://ynoss.oss-cn-hangzhou.aliyuncs.com/upload/20220113/4f1c9ad2553fd0c2e4d0c67644d839f9.png" alt="a">

                </div>
                <button class="btn">业主投票</button>
              </div>
              </script>
       </wx-open-launch-weapp>
      </li>
      <li v-else>
        <router-link to="/home/VotingList">
          <b class="two"></b>
          <div v-if="iscan===1"
               style="width: 10px;height: 10px;background: #ff4444;border-radius: 50%;position: absolute;right: 30px;top: 15px;"></div>
          <span>业主投票</span>
        </router-link>
      </li>
      <li>
        <router-link to="/home/NoticeTab"><b class="one"></b><span>通知公告</span></router-link>
      </li>
      <li>
        <router-link to="/home/Governance"><b class="three"></b><span>收支透明</span></router-link>
      </li>
      <li>
        <!--<router-link to="/home/RentSale"><b class="ten"></b><span>房屋租售</span></router-link>-->
        <a href="/home/RentSale"><b class="four"></b><span>租住中心</span></a>
      </li>
      <li>
        <router-link to="/home/NeighborLife"><b class="five"></b><span>邻里生活</span></router-link>
      </li>
      <!--<li>
        <router-link to="/home/Supervise"><b class="six"></b><span>监理查验</span></router-link>
      </li>-->
      <li>
        <router-link to="/home/SignList"><b class="six"></b><span>选举报名</span></router-link>
      </li>
      <li>
        <router-link to="/home/ResultShow"><b class="seven"></b><span>结果公示</span></router-link>
      </li>
      <!--<li @click="notEnable">
        <a href="javascript:(0);"><b class="eight"></b><span>更多</span></a>
      </li>-->
      <li><a href="/home/PunchClock"><b class="eight"></b><span>员工打卡</span></a></li>
       <!--<li><router-link to="/home/Repairs"><b class="eight"></b><span>物业报修</span></router-link></li>-->
    </ul>
    <div class="split"></div>
    <div class="notice" v-if="flag">
      <div class="title" v-show="details.length">
        <p class="h5">最新公告</p>
        <router-link to="/home/NoticeTab">
          <p>更多 ></p>
        </router-link>
      </div>
      <!--新版-->
      <ul class="fav_list">
        <li class="list_li" @click="$router.push('/home/VillageDetail/'+item.id+'/'+item.type)" v-for="(item,index) in details" :key="index">
          <p>{{item.title}}</p>
          <label class="list_label">
            <img src="./images/back@2x.png" alt="">
          </label>
        </li>
      </ul>
    </div>
    <div class="split" v-show="rentlists.length && details.length"></div>
    <div class="rent-sales" v-if="flag">
      <div class="title border-bottom" v-show="rentlists.length">
        <p class="h5" ref="lat">最新租售</p>
        <router-link to="/home/RentSale">
          <p>更多 >></p>
        </router-link>
      </div>
      <ul>
        <li v-for="(rent,index) in rentlists" :key="index" class="border-bottom-last">
          <router-link :to="'/home/RentDetail/'+rent.id">
            <div class="rent_img">
              <div v-show="rent.img[0]" class="img" :style="'backgroundImage:url('+rent.img[0]+')'"></div>
              <img src="../../assets/imgDefault.png" alt="" v-show="!rent.img[0]">
            </div>
            <span class="des">{{rent.content}}</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="split" v-show="seeklists.length && rentlists.length"></div>
    <div class="linli" v-if="flag">
      <div class="title" v-show="seeklists.length">
        <p class="h5">最新邻里求助</p>
        <router-link to="/home/SeekHelp">
          <p>更多 >></p>
        </router-link>
      </div>
      <mt-cell
        :title="seek.title"
        :to="'/home/HelpDetail/'+seek.id"
        is-link
        v-for="(seek,index) in seeklists" :key="index"
      >
      </mt-cell>
    </div>
    <v-footer></v-footer>
  </div>
</template>
<style lang="scss" scoped>
  @import "../../common/sass/mixin.scss";

  .home {
    background-color: #fff;
    padding-bottom: 60px;
    .mint-cell:last-child {
      background-size: 100% 0;
      .mint-cell-wrapper {
        background-size: 100% 0;
      }
    }
    .search {
      position: relative;
      background-color: #0C7AD9;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 17px;
      color: #fff;
      // @include border-bottom-1px(#d9d9d9);
      .drop {
        display: inline-block;
        .drop-icon {
          display: inline-block;
          width: 16px;
          height: 9px;
          background-size: 16px 9px;
          background-repeat: no-repeat;
          @include bgimg('../header/images/xialajiantou');
        }
      }
      .search-icon {
        position: absolute;
        top: 10px;
        right: 8px;
        width: 18px;
        height: 18px;
        background-size: 18px 18px;
        background-repeat: no-repeat;
        @include bgimg('./images/sousuo');
      }
    }
    .swiper-box {
      height: 160px;
      .mint-swipe {
        width: 100%;
        height: 160px;
        color: #fff;
        font-size: 30px;
        text-align: center;
        .mint-swipe-item {
          img {
            width: 100%;
            height: 160px;
          }
        }
      }
    }
    .mainmenu {
      width: 100%;
      margin: 10px 0 20px 0;
      li {
        float: left;
        width: 25%;
        overflow: hidden;
        position: relative;
        a {
          display: block;
          text-align: center;
          text-decoration: none;
          b {
            display: inline-block;
            margin: 14px auto 7px;
            height: 50px;
            width: 50px;
            background-size: 50px 50px;
            background-repeat: no-repeat;
            @include bgimg("./images/gonggao");
            &.two {
              @include bgimg("./images/vote2");
            }
            &.three {
              @include bgimg("./images/zltm");
            }
            &.four {
              @include bgimg("./images/zszx");
            }
            &.five {
              @include bgimg("./images/linlishenghuo");
            }
            &.six {
              @include bgimg("./images/xuanjubaoming");
            }
            &.seven {
              @include bgimg("./images/result_icon");
            }
            &.eight{
              // @include bgimg("./images/more");
              @include bgimg("./images/clock");
            }
          }
          span {
            display: block;
            color: black;
            font-size: 14px;
          }
        }
      }
    }
    .split {
      width: 100%;
      height: 10px;
      background-color: #F2F2F2;
    }
    .notice {
      padding: 10px 0px 0 0px;
      .title {
        margin: 0 10px;
        padding-bottom: 25px;
        font-size: 15px;
        color: rgb(0, 0, 0);
        // @include border-bottom-1px(#d9d9d9);
        .h5 {
          float: left;
          font-size: 15px;
          color: #000;
          font-weight: bold;
        }
        p {
          float: right;
          font-size: 13px;
          color: #0078de;
        }
      }
      .fav_list{
        margin: 0;
        padding: 0;
        font-size: 100%;
        vertical-align: baseline;
        border: 0;
        display: block;
        overflow: hidden;
        zoom: 1;
        .list_li{
          padding: 14px 10px;
          font-size: 0;
          border-top: 1px solid #f0f0f0;
          list-style: none;
          p{
            width: 95%;
            line-height: 24px;
            font-size: 14px;
            vertical-align: middle;
            color: #353535;
            text-decoration: none;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            overflow: hidden;

          }
          .list_label{
            margin-left: 10px;
            font-size: 14px;
            vertical-align: middle;
            display: inline-block;
            img{
              width: 7px;
            }
          }
        }
      }
    }
    .linli {
      padding: 10px 0px 0 0px;
      .title {
        padding-bottom: 25px;
        font-size: 15px;
        margin: 0 10px;
        color: rgb(0, 0, 0);
        // @include border-bottom-1px(#d9d9d9);
        .h5 {
          float: left;
          font-size: 15px;
          color: #000;
          font-weight: bold;
        }
        p {
          float: right;
          font-size: 13px;
          color: #0078de;
        }
      }
    }
    .rent-sales {
      padding: 10px 10px 0 10px;
      .title {
        padding-bottom: 25px;
        font-size: 15px;
        color: rgb(0, 0, 0);
        // @include border-bottom-1px(#d9d9d9);
        .h5 {
          float: left;
          font-size: 15px;
          color: #000;
          font-weight: bold;
        }
        p {
          float: right;
          font-size: 13px;
          color: #0078de;
        }
      }
      ul {
        li {
          padding: 10px 0;
          height: 55px;
          // @include border-bottom-1px(#d9d9d9);
          // &:last-child {
          //   @include border-none();
          // }
          .rent_img {
            float: left;
            display: inline-block;
            vertical-align: middle;
            font-size: 0;
            height: 55px;
            width: 55px;
            .img {
              width: 100%;
              height: 100%;
              background-size: cover;
            }
            img {
              width: 100%;
              height: 100%;
              background-size: cover;
            }
          }
          .des {
            float: left;
            vertical-align: middle;
            margin-left: 10px;
            // font-weight: 700;
            font-size: 15px;
            color: rgb(41, 41, 41);
            line-height: 55px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 78%;
          }
        }
      }
    }
  }
</style>
<script>
  import headTop from '../header/Header.vue'
  import Footer from '../footer/Footer.vue'
  import commonUrl from '../../common/js/commonUrl.js'
  import {
    loadVillageId,
    loadTitle,
    loadCityId,
    loadCity,
    saveCity,
    saveCityId,
    saveVillageId,
    saveTitle,
    loadOpenId,
    saveOpenId,
    saveUserId,
    loadUserId,
    saveCityCode,
    loadCityCode,
    saveTIME,
    loadTIME,
    saveOVER,
    loadOVER,
    savePhoneName
  } from '../../common/js/cache.js'
  import {getQueryString} from '../../common/js/getQueryString.js'
  import wx from 'weixin-js-sdk'
  import {Toast} from 'mint-ui'
  import {getVillageList, getOpenId, getConfig, getAreasId, passOpenId} from '../../api/homeLogin.js'
  import {IsWeiXin} from '../../common/js/isWeixin'
  import {carPicture} from '../../api/my'

  export default {
    name: 'Home',
    data() {
      return {
        details: [],
        lists: [],
        rentlists: [],
        seeklists: [],
        areaId: loadVillageId(),
        cityId: loadCityId() || 3,
        // cityId: loadCityId(),
        village: loadTitle() || '请选择小区',
        // village: loadTitle(),
        city: loadCity(),
        openid: loadOpenId(),
        userid: loadUserId(),
        flag: false,
        issup: '', // 判断有无事物投票
        iscan: '', // 判断有无选举投票
        newOld: {
          type: String
        }, // 判断新老版本投票
        city_code: loadCityCode,
        time_stamp: '', // 获取当前时间戳用于跟缓存时间戳进行判断
        over: false, // 判断用户登录是否过期
        numberPhon: '', // 用来存放用户登录时的电话号码
        nameReal: '', // 用来存放用户登录时的真实姓名
        num: '1', // 图片轮播参数
        picture: [] // 图片轮播数据
      }
    },
    created() {
      this._getLatLng()
      if (loadVillageId()) {
        this.areaId = loadVillageId()
        this._getVillageList(this.areaId)
      }
      // 如果是用户搜索小区进入页面的话通过url地址来保存小区id小区名称城市id城市名称
      if (getQueryString('areas_id') && getQueryString('code') === null) {
        this.village = getQueryString('areas_name')
        this.cityId = parseInt(getQueryString('city_id'))
        this.city = getQueryString('city_name')
        // this.openid = getQueryString('open_id')
        this.areaId = parseInt(getQueryString('areas_id'))
        saveCity(this.city)
        saveCityId(this.cityId)
        saveVillageId(this.areaId)
        saveTitle(this.village)
        if (this.openid) {
          saveOpenId(this.openid)
          this._passOpenId(this.openid)
        } else {
          // window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxae1d85bfd66812e6&redirect_uri=https%3A%2F%2Fynwx.zgwyzxw.cn%2Fh%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
        }
      }
      // 判断是否是微信浏览器
      if (IsWeiXin()) {
        if (!getQueryString('code') && !this.openid && !this.userid) {
          // 重定向页面，域名发生改变
          // 测试
          // window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxae1d85bfd66812e6&redirect_uri=https%3A%2F%2Fynwx.zgwyzxw.cn%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
          // 中正正式
          window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5effd0de8eaddf30&redirect_uri=https%3A%2F%2Fzzwx.yzptzx.cn%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
        }
        this.over = loadOVER()
        if (getQueryString('code') != null && ((!this.openid && !this.userid) || this.over)) {
          this.over = false
          this._getOpenId()
        } else {
          this.time_stamp = new Date().getTime()
          if (loadTIME() === undefined || loadTIME() + 2592000000 < this.time_stamp) {
            saveOVER(true)
            // 测试
            // window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxae1d85bfd66812e6&redirect_uri=https%3A%2F%2Fynwx.zgwyzxw.cn%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
            // 中正正式
            window.location = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5effd0de8eaddf30&redirect_uri=https%3A%2F%2Fzzwx.yzptzx.cn%2Fhome&response_type=code&scope=snsapi_userinfo&state=89e0440c0f961acf72521cda57d897f0#wechat_redirect'
          }
        }
        if (loadOpenId() && !this.userid) {
          this._passOpenId(loadOpenId())
        }
      } else {
        this.time_stamp = new Date().getTime()
        if (loadTIME() === undefined || loadTIME() + 2592000000 < this.time_stamp) {
          this.$router.push('/Login')
        }
      }
      this._carPicture() // 图片轮播
    },
    methods: {
      _getLatLng() {
        getConfig().then(res => {
          if (res.code === 200) {
            wx.config({
              debug: false,
              appId: res.data.appId,
              nonceStr: res.data.nonceStr,
              rawString: res.data.rawString,
              signature: res.data.signature,
              timestamp: res.data.timestamp,
              jsApiList: [
                'getLocation',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone'
              ],
              openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
            })
            var th = this
            wx.ready(() => {
              if (!loadVillageId()) {
                wx.getLocation({
                  type: 'gcj02',
                  success: function (res) {
                    th._getAreasId(res.longitude, res.latitude)
                  },
                  cancel: function () {
                    saveCity('杭州')
                    saveCityId(3)
                  },
                  fail: function () {
                    saveCity('杭州')
                    saveCityId(3)
                  }
                })
                if (!loadVillageId()) {
                  saveCity('杭州')
                  saveCityId(3)
                }
              }
              setTimeout(function () {
                var params = {
                  title: '业主在线', // 分享标题
                  desc: loadTitle(),
                  link: `${commonUrl.apihost}home?areas_name=${loadTitle()}&areas_id=${loadVillageId()}&city_id=${loadCityId()}&city_name=${loadCity()}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: 'http://pic.yzptzx.cn/forum/20180820171242_15347563625b7a860a349a0', // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                  }
                }
                wx.onMenuShareTimeline(params)
                wx.onMenuShareAppMessage(params)
                wx.onMenuShareQQ(params)
                wx.onMenuShareWeibo(params)
                wx.onMenuShareQZone(params)
              }, 1000)
            })
          }
        })
      },
      // 去城市页面
      toChoseCity() {
        this.$router.push('/home/ChoseCity')
      },
      // 通过经纬度来获取小区名称,小区id，城市名称，城市id并保存
      _getAreasId(lng, lat) {
        getAreasId(lng, lat).then(res => {
          this.areaId = res.data.areas_id
          this.village = res.data.village
          this.cityId = res.data.city_id
          this.city = res.data.city_title
          this.city_code = res.data.city_code
          // 保存城市名称和城市id
          saveCity(this.city)
          saveCityId(this.cityId)
          saveVillageId(this.areaId)
          saveTitle(this.village)
          saveCityCode(this.city_code)
          // 调用获取首页公告
          this._getVillageList(this.areaId)
        })
      },
      // 刚进首页通过经纬度后通过小区id获取当前小区公告，租售列表，求助列表
      _getVillageList(id) {
        getVillageList(id).then(res => {
          if (res.code === 200) {
            this.details = res.data.article
            this.rentlists = res.data.house
            this.seeklists = res.data.neighbor
            // isSup和isCan 0是没有投票  1是有投票
            this.issup = res.data.isSup
            this.iscan = res.data.isCan
            this.flag = true
            this.newOld = res.data.type
            console.log(this.newOld)
          }
        })
      },
      // 获取微信用户openId和userid
      _getOpenId() {
        getOpenId().then(res => {
          // console.log(res)
          if (res.code === 200) {
            this.openid = res.data[0].open_id
            this.userid = res.data[0].id
            this.numberPhon = res.data[0].phone
            this.nameReal = res.data[0].real_name
            if (this.numberPhon !== '' && this.nameReal !== '') {
              const PandN = {
                phone: this.numberPhon,
                name: this.nameReal
              }
              savePhoneName(PandN)
            }
            saveOpenId(this.openid)
            saveUserId(this.userid)
            saveTIME(new Date().getTime()) // 存储时间用于判断是否过期
            saveOVER(this.over) // 存储是否过期的标识
          }
        })
      },
      // 有openid没有userid就存userid
      _passOpenId(id) {
        passOpenId(id).then(res => {
          this.userid = res.data[0].id
          saveUserId(this.userid)
        })
      },
      // 更多
      notEnable () {
        Toast({
          message: '更多功能正在开发中',
          position: 'middle',
          duration: 1500
        })
      },
      // 图片轮播
      _carPicture() {
        carPicture(this.num).then(res => {
          // console.log(res)
          if (res.code === 200) {
            this.picture = res.data
            // console.log(this.picture)
          }
          if (res.code === 400) {
            Toast({
              message: res.msg,
              position: 'middle',
              duration: 1500
            })
          }
        })
      }
    },
    components: {
      headTop,
      'v-footer': Footer
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue